/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Plan_Choose_T1Inputs */

const en_dr_plan_choose_t1 = /** @type {(inputs: Dr_Plan_Choose_T1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem & users`)
};

const id_dr_plan_choose_t1 = /** @type {(inputs: Dr_Plan_Choose_T1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masalah & pengguna`)
};

/**
* | output |
* | --- |
* | "Problem & users" |
*
* @param {Dr_Plan_Choose_T1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_plan_choose_t1 = /** @type {((inputs?: Dr_Plan_Choose_T1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Plan_Choose_T1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_plan_choose_t1(inputs)
	return en_dr_plan_choose_t1(inputs)
});